import { useState, useCallback } from 'react';

type SortOrder = 'asc' | 'desc';

interface MenuItem {
  label: string;
  onClick?: () => void;
}

interface UseSortingAccordionResult {
  sortOrder: SortOrder;
  selectedTitle: string;
  menuItems: MenuItem[];
  setSelectedTitle: (title: string) => void;
}

export const useSortingAccordion = (
  defaultOrder: SortOrder = 'asc'
): UseSortingAccordionResult => {
  const [sortOrder, setSortOrder] = useState<SortOrder>(defaultOrder);
  const [selectedTitle, setSelectedTitle] = useState<string>(
    defaultOrder === 'asc' ? 'Ascending (Name)' : 'Descending (Name)'
  );

  const handleSort = useCallback((order: SortOrder) => {
    setSortOrder(order);
    setSelectedTitle(order === 'asc' ? 'Ascending (Name)' : 'Descending (Name)');
  }, []);

  const menuItems: MenuItem[] = [
    { label: 'Ascending (Name)', onClick: () => handleSort('asc') },
    { label: 'Descending (Name)', onClick: () => handleSort('desc') },
  ];

  return {
    sortOrder,
    selectedTitle,
    menuItems,
    setSelectedTitle,
  };
};
